import React, { useState, useEffect } from "react";
import { Route, Redirect, useHistory } from "react-router-dom";
import { fetchAuthSession } from "aws-amplify/auth";
import { Routes } from "../routes";

const PrivateRoute = ({ render: Component, ...rest }) => {
  const [authenticated, setAuthenticated] = useState(null);
  const history = useHistory();

  useEffect(() => {
    const checkAuth = async () => {
      try {
        const session = await fetchAuthSession(); // auto-refreshes if the refresh token is valid
        const idToken = session.tokens?.idToken;
        if (!idToken) {
          throw new Error("No ID token in session");
        }
        setAuthenticated(true);
      } catch (err) {
        console.warn("PrivateRoute: not authenticated or session expired:", err?.name ?? err);
        setAuthenticated(false);
        history.push("/login?reason=session_invalid");
      }
    };

    checkAuth();
  }, [history]);

  if (authenticated === null) {
    return null;
  }

  return (
    <Route
      {...rest}
      render={(props) =>
        authenticated ? (
          Component(props)
        ) : (
          <Redirect to={Routes.Signin.path} />
        )
      }
    />
  );
};

export default PrivateRoute;
